var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15186 22.3931H9.72232V25.0247H6.15186V22.3931Z",
    fill: "#2C72DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6562 15.4204H2.34377C1.04932 15.4204 0 16.4682 0 17.7608V37.6598C0 38.9523 1.04932 40.0001 2.34377 40.0001H37.6562C38.9507 40.0001 40 38.9523 40 37.6597V17.7608C40 16.4682 38.9507 15.4204 37.6562 15.4204ZM9.45253 34.9217H3.65144V32.5814H9.45253V34.9217ZM12.0654 25.413C12.0654 26.4883 11.1892 27.3632 10.1123 27.3632H5.76048C4.68355 27.3632 3.80738 26.4883 3.80738 25.413V22.0012C3.80738 20.9259 4.68355 20.051 5.76048 20.051H10.1122C11.1891 20.051 12.0653 20.9259 12.0653 22.0012L12.0654 25.413ZM18.4178 34.9217H12.6168V32.5814H18.4178V34.9217ZM27.3832 34.9217H21.5822V32.5814H27.3832V34.9217ZM36.3486 34.9217H30.5475V32.5814H36.3486V34.9217Z",
    fill: "#2C72DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4632 5.6851L26.4563 0.685466C25.541 -0.228488 24.0571 -0.228488 23.1417 0.685466L10.7271 13.0821H24.4787L31.4632 5.6851Z",
    fill: "#2C72DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3185 13.0814L34.9833 9.20018L33.1205 7.34009L27.6992 13.0814H31.3185Z",
    fill: "#2C72DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6551 13.0813C38.1585 13.0813 38.6433 13.1619 39.0982 13.3093L36.6411 10.8557L34.5396 13.0814L37.6551 13.0813Z",
    fill: "#2C72DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.9a0559c264ca8e5ef8f06e5222929b16.svg";
export { ForwardRef as ReactComponent };